// @catalog F.010
/**
 * finalLineQty — B5.3 (override de REPOSICIÓN propaga a TOTAL/MARGEN/CSV).
 *
 * Cantidad final de una línea de compra. Única fuente de verdad para que la
 * pantalla (TOTAL/MARGEN por fila + gran total), el PO y el CSV den el MISMO
 * número. `baseSuggested` es `qty_compra_final` de C3: YA incluye muestras y
 * el redondeo de pack del backend. Cascada:
 *   1. override de suggestedPlus (compra final) reemplaza el total.
 *   2. override de REPOSICIÓN reemplaza la parte regular; se agrega la muestra
 *      una sola vez.
 *   3. sin overrides se usa la cantidad canónica C3 sin volver a sumar muestra.
 * El extra de crecimiento se agrega antes de un único redondeo final al pack
 * efectivo elegido por el comprador.
 *
 * Bug #1 (auditoría F6): antes la pantalla ignoraba el override de REPOSICIÓN
 * (usaba baseSuggested), mientras CSV/PO sí lo honraban → "4 valores por SKU".
 * Nota: los productos con override de REPOSICIÓN quedan excluidos del reparto de
 * crecimiento (extraQty = 0 para ellos).
 */
export function finalLineQty(opts: {
  baseSuggested: number;
  suggestedOverride?: number | undefined;
  suggestedPlusOverride?: number | undefined;
  sampleQty: number;
  extraQty: number;
  packSize: number;
}): number {
  const {
    baseSuggested,
    suggestedOverride,
    suggestedPlusOverride,
    sampleQty,
    extraQty,
    packSize,
  } = opts;
  const rawQty =
    typeof suggestedPlusOverride === "number"
      ? suggestedPlusOverride
      : typeof suggestedOverride === "number"
        ? suggestedOverride + sampleQty + extraQty
        : baseSuggested + extraQty;
  const wholeUnits = Math.ceil(Math.max(0, Number(rawQty) || 0));
  const normalizedPack = Math.max(1, Math.floor(Number(packSize) || 1));
  return Math.ceil(wholeUnits / normalizedPack) * normalizedPack;
}
